<template>
  <div class="body">
    <img class="Bgc" :src="IscSchedule_2023.bgc" alt="背景图" />
    <div class="nav">
      <div class="navTitle">{{ IscSchedule_2023.title }}</div>
      <div class="navDesc">{{ IscSchedule_2023.desc }}</div>
      <ul class="navList">
        <li
          class="navListLi"
          :class="{
            pitch: pitch === index,
            pitch_first: (pitch + 1) % 3 === index,
            pitch_second: (pitch + 2) % 3 === index
          }"
          v-for="(item, index) in List"
          :key="index"
          @click="toJump(index)"
        >
          <div class="navListLiDate">{{ item.date.slice(5) }}</div>
          <div class="navListLiTitle">{{ item.title }}</div>
          <div v-if="pitch === index" class="navListLiLine" />
        </li>
      </ul>
      <div class="navDate" v-if="List[pitch]">
        <img :src="navBgcLogo" alt="背景logo" class="navDateBgc" />
        <div class="wrap">
          <div class="navDateSchedule" v-for="(item, index) in pageList" :key="index">
            <div v-if="item.time" class="navDateScheduleTime">{{ item.time }}</div>
            <div class="navDateScheduleImg">
              <img
                class="navDateScheduleDot"
                :class="!item.time ? 'clearMarginLeft' : ''"
                :src="dot"
                alt="绿点"
              />
            </div>
            <div
              v-if="pageList.length > 1 && index !== pageList.length - 1"
              class="navDateScheduleLine"
            ></div>
            <span class="navDateScheduleTitle" @click="toJumpPage(item.link)">
              {{ item.title }}</span
            >
          </div>
        </div>
      </div>
      <div v-if="pageSum > 1" class="navPage">
        <div class="navPageNum">
          <span class="navPageNumCur">{{ pageCurr }}</span>
          <span class="navPageNumSum">/{{ pageSum }}</span>
        </div>
        <Btn :navArr="List" :stopId="pageSum" @fetchNav="fetchNav" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getIscSchedule } from '@/api/2023/index.js'
import Btn from '@/components/common/2023/button.vue'
import { IscSchedule_2023 } from '@/mock/2023isc/data.js'
const dot = 'https://s1.ssl.qhres2.com/static/f7d5824ea303d286.svg'
const navBgcLogo = 'https://p2.ssl.qhimg.com/t016c97eeb3ba61e5b5.png'
const List = ref([])
const pitch = ref(0)
const pageList = ref([])
const pageCurr = ref(1)
const pageSum = ref(1) // 总页数
const PAGR_SIZE = 8
onBeforeMount(async () => {
  await fetchInfo()
})

function updataPageList() {
  const newPage = (pageCurr.value - 1) * PAGR_SIZE
  const newLeg = List.value[pitch.value].list
  pageList.value = newLeg.slice(newPage, newPage + PAGR_SIZE)
}
function updataPageNum() {
  pageCurr.value = 1
  pageSum.value = 1
  const listLength = List.value[pitch.value].list.length
  pageSum.value = Math.ceil(listLength / PAGR_SIZE)
}
function fetchNav(val) {
  pageCurr.value = val + 1
  updataPageList()
}
async function fetchInfo() {
  await getIscSchedule()
    .then((res) => {
      List.value = res.data.data
      updataPageList()
      updataPageNum()
    })
    .catch(() => {})
}
function toJump(index) {
  pitch.value = index
  updataPageList()
  updataPageNum()
}

function toJumpPage(link) {
  if (link) {
    window.open(link, '_blank')
  }
}
</script>

<style lang="scss" scoped>
.pitch {
  background: rgba(0, 171, 122, 0.96);
}
.pitch_first {
  background: rgba(10, 104, 87, 0.9);
}
.pitch_second {
  background: rgba(10, 104, 87, 0.7);
}
.body {
  position: relative;

  height: 678px;
  .Bgc {
    float: left;
  }
}
.nav {
  position: absolute;
  top: 29px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  &Title {
    font-size: 16px;
    line-height: 25px;
    color: #00ab7a;
  }
  &Desc {
    font-size: 11px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0px 0 18px;
  }
  &List {
    display: flex;
    justify-content: space-between;
    margin: 0;
    &Li {
      padding: 14px 14px 5px 14px;
      list-style: none;
      flex: 1;
      height: 85px;
      &Date {
        font-size: 14px;
        line-height: 14px;
        color: rgba(255, 255, 255, 0.9);
      }
      &Title {
        white-space: pre-wrap;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
        margin: 6px 0;
      }
      &Line {
        width: 29px;
        height: 3px;
        background-color: #fff;
      }
    }
  }
  &Date {
    position: relative;
    width: 100%;
    min-height: 455px;
    padding: 20px 13px 16px 13px;
    box-shadow: 0px 3.62px 9.06px 0px rgba(0, 31, 138, 0.15);
    background-color: #fff;
    overflow: hidden;
    &Bgc {
      position: absolute;
      right: 2px;
      bottom: 0px;
      width: 202px;
    }
    .wrap {
      position: relative;
      overflow: hidden;
    }
    &Schedule {
      display: flex;
      // justify-content: space-around;
      justify-content: flex-start;
      align-items: center;
      margin-top: 6px;
      &Time {
        font-size: 12px;
        min-width: 74px;
        color: #8a9099;
        height: 100%;
      }
      &Img {
        position: relative;
      }
      .clearMarginLeft {
        margin-left: 0;
      }
      &Dot {
        width: 12px;
        margin: 0px 11px;
        z-index: 1;
      }
      &Line {
        position: absolute;
        top: 22px;
        left: 91px;
        min-height: 20px;
        height: calc(100% + 10px);
        opacity: 0.4;
        border: 1px dashed #00ab7a;
      }
      &Title {
        // width: 218px;
        font-size: 14px;
        color: #3d3d3d;
      }
    }
    &Schedule:first-child {
      margin: 0;
    }
  }
  &Page {
    position: absolute;
    bottom: 8px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 56px;
    background-color: transparent;
    padding: 0 16px 0 16px;
    &Num {
      font-size: 22px;
      line-height: 22px;
      &Cur {
        color: rgb(102, 102, 102);
      }
      &Sum {
        color: rgb(178, 178, 178);
      }
    }
  }
}
</style>
